import type { GetServerSidePropsContext, NextPage } from 'next';
import { useRouter } from 'next/router';
import Container from '../../components/container/container.component';
import Facets from '../../components/facets/facets.component';
import LociTableComponent from '../../components/loci-table/loci-table.component';
import Pagination from '../../components/pagination/pagination.component';
import { getLoci } from '../../lib';
import PageTemplate from '../../templates/page.template';
import { LociListProps } from '../../types/loci-list-props.interface';

interface Props extends LociListProps { }

const FindsListPage: NextPage<Props> = ({
  options,
  menu,
  prev,
  next,
  facetDistribution,
  hits,
  nbHits,
  initialFacets,
  baseFacets,
}) => {
  const router = useRouter();
  return (
    <PageTemplate
      menu={menu}
      options={options}
      title={'Browse loci'}
      description={options.description}
      isInitiallyDark={true}
    >
      <Container
        css={{ height: 'auto', minHeight: 'calc(100vh - 240px)' }}
        column={true}
      >
        <h1 className="pageHeader">Browse loci</h1>
        <div className="columnsWrapper">
          <div>
            <Facets
              facets={facetDistribution}
              initialValues={initialFacets}
              baseFacets={baseFacets}
              type="loci"
            />
          </div>
          <div>
            <LociTableComponent loci={hits} prev={prev[0]} next={next[0]} />
          </div>
          <Pagination router={router} nbHits={nbHits} />
        </div>
      </Container>
    </PageTemplate>
  );
};
export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const {
    facetDistribution,
    hits,
    menu,
    options,
    estimatedTotalHits,
    baseFacets,
    prev,
    next,
  } = await getLoci(Number(ctx.query.page) || 0);
  const initialFacets: { [key: string]: string[] } = {};
  for (const facet of Object.keys(facetDistribution)) {
    initialFacets[facet] = [];
  }

  ctx.res.setHeader('Cache-Control', 'public, max-age=300, s-maxage=300');

  return {
    props: {
      prev: prev ? prev.hits : [],
      next: next.hits,
      facetDistribution,
      hits,
      nbHits: estimatedTotalHits,
      initialFacets,
      baseFacets,
      menu,
      options,
    },
  };
}

export default FindsListPage;
